import React from 'react'
import {Link} from 'startlibs/lib/components'
import {ExpiredPageComponent, ContentBox} from './ExpiredShare'

export class DeleteAccountFinished extends React.PureComponent {

  render() {
    return (
      <ExpiredPageComponent centered grayNavbar>
        <div className="navbar">
          <Link skipTo="/" className="logo">Horos Cloud</Link>
        </div>
        <ContentBox topImage>
          <img src="/public/account-deleted.png" alt="Expired" />
          <h2>Account deleted successfully.</h2>
          <p>Thank you for using Horos Cloud</p>
        </ContentBox>
        <div className="useful-links">
          <div>Here are some useful links</div>
          <a className="link" href="https://horosproject.org">Horos Project website</a>
          <a className="link" href="https://horosproject.org/download-horos/">Download Horos</a>
          <Link className="link" skipTo="/">Horos Cloud home</Link>
        </div>
      </ExpiredPageComponent>
    )
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/public/DeleteAccountFinished.jsx